/**
 * External Dependencies
 */
import 'jquery';
import 'parsleyjs';

$(() => {
  // Global constants
  const $body = $('body'),
        menuToggleId = 'menu-active',
        $menuToggleLabel = $('[for="' + menuToggleId + '"]'),
        $menuToggle = $('#' + menuToggleId);

  // Lock the body on menu toggle to prevent scrolling behind the nav drawer
  const menuToggleActiveClass = 'overflow-hidden';

  $menuToggle.on('change', (e) => {
    if ($(e.target).prop('checked')) {
      $menuToggleLabel.attr('aria-expanded', 'true');
      $body.addClass(menuToggleActiveClass);
    } else {
      $menuToggleLabel.attr('aria-expanded', 'false');
      $body.removeClass(menuToggleActiveClass);
    }
  });

  // Modal functions
  let openModal = (modal) => {
    const $modal = $(modal);

    if ($modal.length) {
      const $modalBg = $modal.find('.modal-bg'),
            $modalDialog = $modal.find('.modal-dialog'),
            animateClass = 'ease-out duration-300',
            translateFromClass = 'translate-y-4 md:translate-y-0 md:scale-95',
            translateToClass = 'translate-y-0 md:scale-100';
            
      $body.addClass('overflow-hidden');
      $modal.removeClass('hidden');
      $modal.addClass('fixed');
      $modalBg.addClass('opacity-0 ' + animateClass);
      $modalDialog.addClass('opacity-0 ' + translateFromClass + ' ' + animateClass);

      setTimeout(() => {
        $modalBg.removeClass('opacity-0');
        $modalBg.addClass('opacity-100');
        $modalDialog.removeClass('opacity-0 ' + translateFromClass);
        $modalDialog.addClass('opacity-100 ' + translateToClass);

        setTimeout(() => {
          $modalBg.removeClass(animateClass);
          $modalDialog.removeClass(animateClass);
        }, 300);
      }, 5);

      return true;
    }

    return false;
  };

  let closeModal = (modal) => {
    const $modal = $(modal);

    if ($modal.length) {
      const $modalBg = $modal.find('.modal-bg'),
            $modalDialog = $modal.find('.modal-dialog'),
            animateClass = 'ease-in duration-150',
            translateFromClass = 'translate-y-0 md:scale-100',
            translateToClass = 'translate-y-4 md:translate-y-0 md:scale-95';
            
      $modalBg.addClass('opacity-100 ' + animateClass);
      $modalDialog.addClass('opacity-100 ' + translateFromClass + ' ' + animateClass);

      setTimeout(() => {
        $modalBg.removeClass('opacity-100');
        $modalBg.addClass('opacity-0');
        $modalDialog.removeClass('opacity-100 ' + translateFromClass);
        $modalDialog.addClass('opacity-0 ' + translateToClass);

        setTimeout(() => {
          $modalBg.removeClass(animateClass);
          $modalDialog.removeClass(animateClass);
          $modal.removeClass('fixed');
          $modal.addClass('hidden');
          $body.removeClass('overflow-hidden');
        }, 300);
      }, 5);

      return true;
    }

    return false;
  };

  // Modal triggers
  $('[data-modal]').click((e) => {
    e.preventDefault();

    const $modalTrigger = $(e.target).closest('[data-modal]'),
          modalId = $modalTrigger.data('modal');

    openModal('#' + modalId);
  });

  $('[data-close-modal]').click((e) => {
    e.preventDefault();

    const $modal = $(e.target).closest('.modal'),
          modalId = $modal.attr('id');

    closeModal('#' + modalId);
  });

  // Ajax form submission
  const $ajaxForms = $('[data-wp-ajax]');

  $ajaxForms.on('submit', (e) => {
    e.preventDefault();

    const form = e.target,
          $formSubmit = $(form).find('[type="submit"]'),
          $formInput = $(form).find('[data-wp-ajax-input]'),
          $formSuccess = $(form).find('[data-wp-ajax-success]');

    $formSubmit.attr('disabled', 'disabled');
    
    $.ajax(form.action, {
      method: form.method,
      data: $(form).serialize(),
      success: function(r) {
        $formInput.addClass('opacity-0');
        $formInput.addClass('pointer-events-none');
        $formSuccess.removeClass('hidden');
      },
      error: function() {
        alert('Something went wrong');
      },
    });
  });
});
